/**
 * Important: Enums have to updated with ProjectTimeValidationCategory.java
 */
export enum ProjectTimeValidationCategory {
	PROJECT_TIME_OVERLAP = "PROJECT_TIME_OVERLAP",
	PROJECT_TIME_MISSING_WORKING_TIME = "PROJECT_TIME_MISSING_WORKING_TIME",
	PROJECT_TIME_TOO_LONG = "PROJECT_TIME_TOO_LONG",
	PROJECT_TIME_STOPPED_OUTSIDE_GEOFENCE = "PROJECT_TIME_STOPPED_OUTSIDE_GEOFENCE",
	PROJECT_TIME_CUT_FLEX_TIME_START = "PROJECT_TIME_CUT_FLEX_TIME_START",
	PROJECT_TIME_CUT_FLEX_TIME_END = "PROJECT_TIME_CUT_FLEX_TIME_END",
	PROJECT_TIME_CUT_NORMAL_WORKING_TIME_START = "PROJECT_TIME_CUT_NORMAL_WORKING_TIME_START",
	PROJECT_TIME_CUT_NORMAL_WORKING_TIME_END = "PROJECT_TIME_CUT_NORMAL_WORKING_TIME_END",
	PROJECT_TIME_CUT_TASK_START = "PROJECT_TIME_CUT_TASK_START",
	PROJECT_TIME_CUT_TASK_END = "PROJECT_TIME_CUT_TASK_END",
	PROJECT_TIME_BREAK_BELOW_LEGAL_MINIMUM = "PROJECT_TIME_BREAK_BELOW_LEGAL_MINIMUM",
	PROJECT_TIME_DATE_EDITED_OUTSIDE_DAY_RANGE = "PROJECT_TIME_DATE_EDITED_OUTSIDE_DAY_RANGE"
}

/**
 * Important: Enums have to updated with WorkingTimeValidationCategory.java
 */
export enum WorkingTimeValidationCategory {
	OVERLAP = "OVERLAP",
	DAILY_REST_PERIOD = "DAILY_REST_PERIOD",
	WEEKLY_REST_PERIOD_INSIDE = "WEEKLY_REST_PERIOD_INSIDE",
	WEEKLY_REST_PERIOD_TOO_SHORT = "WEEKLY_REST_PERIOD_TOO_SHORT",
	SUNDAY_REST_PERIOD_INSIDE = "SUNDAY_REST_PERIOD_INSIDE",
	HOLIDAY_REST_PERIOD_INSIDE = "HOLIDAY_REST_PERIOD_INSIDE",
	HOLIDAY_REST_PERIOD_TOO_SHORT = "HOLIDAY_REST_PERIOD_TOO_SHORT",
	TOO_LONG = "TOO_LONG",
	OUTSIDE_FLEX_TIME = "OUTSIDE_FLEX_TIME",
	CUT_EXCEEDING_MAX_DAILY_DURATION = "CUT_EXCEEDING_MAX_DAILY_DURATION",
	CUT_FLEX_TIME_START = "CUT_FLEX_TIME_START",
	CUT_FLEX_TIME_END = "CUT_FLEX_TIME_END",
	CUT_NORMAL_WORKING_TIME_START = "CUT_NORMAL_WORKING_TIME_START",
	CUT_NORMAL_WORKING_TIME_END = "CUT_NORMAL_WORKING_TIME_END",
	BREAK_BELOW_LEGAL_MINIMUM = "BREAK_BELOW_LEGAL_MINIMUM",
	VACATION_ON_NON_WORKING_DAY = "VACATION_ON_NON_WORKING_DAY",
	PAID_OFF_ON_NON_WORKING_DAY = "PAID_OFF_ON_NON_WORKING_DAY",
	WORKING_TIME_ON_NON_WORKING_DAY = "WORKING_TIME_ON_NON_WORKING_DAY",
	VACATION_ON_HOLIDAY = "VACATION_ON_HOLIDAY",
	PAID_TIME_OFF_ON_HOLIDAY = "PAID_TIME_OFF_ON_HOLIDAY",
	ENTRY_ON_HOLIDAY = "ENTRY_ON_HOLIDAY",
	PAID_TIME_OFF_ON_WHOLE_DAY = "PAID_TIME_OFF_ON_WHOLE_DAY",
	VACATION_ON_WHOLE_DAY = "VACATION_ON_WHOLE_DAY",
	UNPAID_TIME_OFF_ON_WHOLE_DAY = "UNPAID_TIME_OFF_ON_WHOLE_DAY",
	ATTENDANCE_TIME_ON_WHOLE_DAY = "ATTENDANCE_TIME_ON_WHOLE_DAY",
	SUSPENSION_ON_WHOLE_DAY = "SUSPENSION_ON_WHOLE_DAY",
	PROJECT_TIME_RATIO_NOT_ACHIEVED = "PROJECT_TIME_RATIO_NOT_ACHIEVED",
	MAXIMUM_WORK_DURATION_DAILY = "MAXIMUM_WORK_DURATION_DAILY",
	MAXIMUM_WORK_DURATION_WEEKLY = "MAXIMUM_WORK_DURATION_WEEKLY",
	OVERTIME_ALLOWANCE = "OVERTIME_ALLOWANCE",
	MISSING_WORKING_TIME_ENTRY = "MISSING_WORKING_TIME_ENTRY",
	MISSING_WORKING_TIME_ENTRY_HALF_DAY = "MISSING_WORKING_TIME_ENTRY_HALF_DAY",
	DATE_EDITED_OUTSIDE_DAY_RANGE = "DATE_EDITED_OUTSIDE_DAY_RANGE",
	PROJECT_TIME_EXCEEDS_WORKING_TIME = "PROJECT_TIME_EXCEEDS_WORKING_TIME",
	WORKING_TIME_ADDED_FUTURE_DATE = "WORKING_TIME_ADDED_FUTURE_DATE",
	PROJECT_TIME_ADDED_FUTURE_DATE = "PROJECT_TIME_ADDED_FUTURE_DATE"
}

export enum AggregateRecordingValidationCategory {
	ALL_WORKING_TIME = "ALL_WORKING_TIME",
	ALL_PROJECT_TIME = "ALL_PROJECT_TIME"
}

export enum CustomFieldsForRecordType {
	Checkbox = "CHECKBOX",
	Number = "NUMBER",
	Options = "OPTIONS",
	String = "STRING"
}

export enum RecordedEntryStatus {
	Changeable = 100,
	Locked = 200,
	Approved = 250,
	Cleared = 300,
	Closed = 400,
	Archived = 500
}

/**
 * String status keys as returned by DTO APIs for working time, project time, and drive log records.
 * Report types use numeric {@link RecordedEntryStatus} values.
 */
export type RecordedEntryStatusKey = "CHANGEABLE" | "LOCKED" | "APPROVED" | "CLEARED" | "CLOSED" | "ARCHIVED";

/**
 * Defines recording procedure for the combined recording flow actions like start, stop, switch, etc.
 * - ProjectTime: project time only
 * - WorkingTime: working time only
 * - Both: working time and project
 */
export enum RecordingProcedure {
	Both = "BOTH",
	WorkingTime = "WORKING_TIME",
	ProjectTime = "PROJECT_TIME"
}

export enum TimelineMode {
	Weekly = "WEEKLY",
	Daily = "DAILY"
}

export enum WorkingTimeTypeCategory {
	AttendanceTime = "ATTENDANCE_TIME",
	Vacation = "VACATION",
	PaidTimeOff = "PAID_TIME_OFF",
	UnpaidTimeOff = "UNPAID_TIME_OFF",
	Suspension = "SUSPENSION",
	BreakTime = "BREAK_TIME"
}

export enum WorkingTimeTypeSubCategory {
	Present = "PRESENT",
	Away = "AWAY",
	WorkFromHome = "WORK_FROM_HOME",
	ActiveDrivingTime = "ACTIVE_DRIVING_TIME",
	PassiveTravellingTime = "PASSIVE_TRAVELLING_TIME"
}

export enum VacationUnit {
	Days = "DAYS",
	Minutes = "MINUTES"
}

export enum DurationUnit {
	Days = "DAYS",
	HalfDays = "HALF_DAYS",
	Minutes = "MINUTES"
}

export enum DurationFormat {
	Decimal = "DECIMAL",
	Minutes = "MINUTES"
}

export enum ExportType {
	Pdf = "PDF",
	Csv = "CSV",
	Excel = "Excel",
	Word = "Word",
	Html = "HTML",
	Ical = "ICAL"
}

export enum ExportJobStatus {
	Waiting = "WAITING",
	Running = "RUNNING",
	Success = "SUCCESS",
	Error = "ERROR",
	Cancelled = "CANCELLED"
}

export enum DateTimeChangeableType {
	ByUser = "BY_USER",
	ByUserDayRange = "BY_USER_DAY_RANGE",
	ByGroupLeader = "BY_GROUP_LEADER",
	ByAdmin = "BY_ADMIN"
}

export enum UserSumsChartRange {
	Day, Week, Month
}

export enum WorkingTimeRequestStatus {
	ApprovalRequested = "APPROVAL_REQUESTED",
	InApproval = "IN_APPROVAL",
	Approved = "APPROVED",
	Rejected = "REJECTED",
	CancellationRequested = "CANCELLATION_REQUESTED",
	InCancellation = "IN_CANCELLATION",
	Cancelled = "CANCELLED"
}

export enum WorkingTimeRequestStepType {
	APPROVAL = "APPROVAL",
	CANCELLATION = "CANCELLATION"
}

export enum WorkingTimeRequestStepStatus {
	PENDING = "PENDING",
	ACTIVE = "ACTIVE",
	APPROVED = "APPROVED",
	REJECTED = "REJECTED",
	OVERRULED_APPROVED = "OVERRULED_APPROVED",
	OVERRULED_REJECTED = "OVERRULED_REJECTED",
	OBSOLETE = "OBSOLETE"
}

/**
 * Events that trigger transitions in the WorkingTimeRequest state machine.
 */
export enum WorkingTimeRequestEvent {

	/**
	 * Approve immediately (override request approval chain)
	 */
	APPROVE_IMMEDIATELY = "APPROVE_IMMEDIATELY",

	/**
	 * Reject immediately (override request approval chain)
	 */
	REJECT_IMMEDIATELY = "REJECT_IMMEDIATELY",

	/**
	 * A request approval step has been approved.
	 */
	APPROVE_REQUEST_STEP = "APPROVE_REQUEST_STEP",

	/**
	 * An request approval step has been rejected.
	 */
	REJECT_REQUEST_STEP = "REJECT_REQUEST_STEP",

	/**
	 * Create request (by request owner or admin/team leader).
	 */
	CREATE_REQUEST = "CREATE_REQUEST",

	/**
	 * Create request (by admin/team leader) and approve immediately.
	 */
	CREATE_REQUEST_AND_APPROVE_IMMEDIATELY = "CREATE_REQUEST_AND_APPROVE_IMMEDIATELY",

	/**
	 * Update request (by request owner or admin/team leader).
	 */
	UPDATE_REQUEST = "UPDATE_REQUEST",

	/**
	 * Cancel immediately (override request approval chain).
	 */
	CANCEL_IMMEDIATELY = "CANCEL_IMMEDIATELY",

	/**
	 * Request cancellation by request owner.
	 */
	REQUEST_CANCELLATION = "REQUEST_CANCELLATION",

	/**
	 * Approve cancellation immediately (override request approval chain).
	 */
	APPROVE_CANCELLATION_IMMEDIATELY = "APPROVE_CANCELLATION_IMMEDIATELY",

	/**
	 * Reject cancellation immediately (override request approval chain).
	 */
	REJECT_CANCELLATION_IMMEDIATELY = "REJECT_CANCELLATION_IMMEDIATELY",

	/**
	 * A cancellation step has been approved.
	 */
	APPROVE_CANCELLATION_STEP = "APPROVE_CANCELLATION_STEP",

	/**
	 * A cancellation step has been rejected.
	 */
	REJECT_CANCELLATION_STEP = "REJECT_CANCELLATION_STEP",
}

export enum WorkingTimeTypeRecordingMode {
	NOT_ALLOWED = "NOT_ALLOWED",
	ALLOWED = "ALLOWED",
	BY_REQUEST = "BY_REQUEST"
}

export enum WorkingTimeNoticeMode {
	NONE = "NONE",
	ALLOWED = "ALLOWED",
	NOT_ALLOWED = "NOT_ALLOWED",
	BY_REQUEST = "BY_REQUEST"
}

export enum InvitationStatus {
	Open = "OPEN",
	Accepted = "ACCEPTED",
	Cancelled = "CANCELLED"
}

export enum BudgetPlanningType {
	None = "NONE",
	TaskHourlyRate = "TASK_HOURLY_RATE",
	UserHourlyRate = "USER_HOURLY_RATE",
	FixedPrice = "FIXED_PRICE",
	Inherited = "__INHERITED__"
}

export enum Platform {
	TIMR_WEB = "TIMR_WEB",
	TIMR_MOBILE = "TIMR_MOBILE",
	TOUR_MOBILE = "TOUR_MOBILE",
	TIMR_TERMINAL = "TIMR_TERMINAL",
	SYNC_API = "SYNC_API"
}

export enum RevisionType {
	ADD = "ADD",
	MOD = "MOD",
	DEL = "DEL"
}

export enum WeeklyRestPeriodStrategyType {
	NONE = "NONE",
	WEEKEND = "WEEKEND",
	SUNDAY = "SUNDAY"
}

export enum LocationRequirement {
	OFF = "OFF",
	IF_AVAILABLE = "IF_AVAILABLE",
	REQUIRED = "REQUIRED",
	REQUIRED_1000 = "REQUIRED_1000",
	REQUIRED_250 = "REQUIRED_250",
	REQUIRED_100 = "REQUIRED_100"
}

export enum TargetWorkingTimeType {
	DAILY_TARGET_HOURS = "DAILY_TARGET_HOURS",
	NORMAL_WORKING_TIME = "NORMAL_WORKING_TIME"
}

export enum DeletedStatus {
	NOT_DELETED = "NOT_DELETED", DELETED = "DELETED", CLIENT_DELETED = "CLIENT_DELETED"
}

export enum IntegrationType {
	PERSONIO = "PERSONIO",
	SLACK = "SLACK",
	ADDISON = "ADDISON",
	ADDISON_SYNC = "ADDISON_SYNC",
	JIRA = "JIRA",
	CUSTOM = "CUSTOM",
	BMD = "BMD",
	GOOGLE = "GOOGLE",
	MICROSOFT = "MICROSOFT",
}

export enum ShowCalendarOptions {
	/**
	 * Only current user
	 */
	"PERSONAL",
	/**
	 * Users in groups the current user is member and/or leader of
	 */
	"GROUP",
	/**
	 * Client wide, "other users" absence data.
	 */
	"ALL"
}

export enum TimeAccountEntryType {
	Balancing = "BALANCING",
	VacationBalanceCorrection = "VACATION_BALANCE_CORRECTION",
	WorkBalanceCorrection = "WORK_BALANCE_CORRECTION",
	Initialization = "INITIALIZATION",
	OvertimeCorrection = "OVERTIME_CORRECTION",
	OvertimeTimeAccountTransfer = "OVERTIME_TIME_ACCOUNT_TRANSFER",
	Payoff = "PAYOFF",
	OverTimePayoff = "OVERTIME_PAYOFF",
	Exit = "EXIT",
	ExitPayoff = "EXIT_PAYOFF",
	TravellingTimeTransfer = "TRAVELLING_TIME_TRANSFER",
	TravellingTimeCorrection = "TRAVELLING_TIME_CORRECTION",
	TravellingTimePayoff = "TRAVELLING_TIME_PAYOFF",
	UserEntry = "USER_ENTRY",
	InitializationLegacy = "INITIALIZATION_LEGACY",
	ReEntry = "RE_ENTRY"
}

export enum TimeAccountState {
	NO_TIME_ACCOUNT = "NO_TIME_ACCOUNT",
	INITIALIZED = "INITIALIZED",
	EXIT_LEGACY = "EXIT_LEGACY",
	EXIT = "EXIT"
}

export enum BreakTimeRecordingMode {
	NOT_ALLOWED = "NOT_ALLOWED",
	RECORD_NO_POSITION = "RECORD_NO_POSITION",
	RECORD_WITH_POSITION = "RECORD_WITH_POSITION"
}

/**
 * IMPORTANT Update the java file too: ValidationSeverity.java
 */
export enum ValidationSeverity {
	INFO = "INFO",
	MINOR = "MINOR",
	MAJOR = "MAJOR",
	CRITICAL = "CRITICAL"
}


export enum ExportTimeAccountType {
	ALL = "ALL",
	USER = "USER",
	GROUP = "GROUP"
}

export enum PresenceBoardFilterOptions {
	ALL = "ALL",
	ACTIVE = "ACTIVE",
	BREAK = "BREAK",
	INACTIVE = "INACTIVE"
}

export enum PresenceBoardVisibility {
	OFF = "OFF",
	GROUP = "GROUP",
	ALL = "ALL",
}

export enum PresenceBoardCategory {
	NOW_ACTIVE = "NOW_ACTIVE",
	INACTIVE = "INACTIVE",
	HOLIDAY = "HOLIDAY",
	NO_WORK_DAY = "NO_WORK_DAY",
	ABSENT = "ABSENT"
}

export enum RunningTimeStatus {
	RUNNING = "RUNNING",
	PAUSED = "PAUSED",
}

/**
 * IMPORTANT Update the java file too: RecordingValidationStatus.java
 */
export enum RecordingValidationStatus {
	OPEN = "OPEN",
	ACKNOWLEDGED = "ACKNOWLEDGED",
	CONFIRMED = "CONFIRMED",
	CLOSED = "CLOSED"
}

export enum OvertimeDeductionAccountType {
	TIME_ACCOUNT = "TIME_ACCOUNT",
	OVERTIME_ALLOWANCE_ACCOUNT = "OVERTIME_ALLOWANCE_ACCOUNT",
	TRAVELLING_TIME_ACCOUNT = "TRAVELLING_TIME_ACCOUNT"
}

/**
 * For ADDISON export
 */
export enum IncapacityReason {
	/**
	 * Incapacity to work due to illness Contract doctor / contract dentist
	 */
	ILLNESS = "ILLNESS",
	/**
	 * Incapacity for work due to an accident at work and occupational illness
	 */
	WORK_INCIDENT = "WORK_INCIDENT",
	/**
	 * Inability to work during inpatient hospital treatment Health insurance fund
	 */
	HOSPITAL_STAY = "HOSPITAL_STAY"
}

/**
 *
 */
export enum FeatureModuleKey {
	// base feature modules
	WORKING_TIME = "WORKING_TIME",
	PROJECT_TIME = "PROJECT_TIME",
	DRIVE_LOG = "DRIVE_LOG",

	// free feature modules
	FREE_WORKING_TIME = "FREE_WORKING_TIME",
	FREE_PROJECT_TIME = "FREE_PROJECT_TIME",
	FREE_DRIVE_LOG = "FREE_DRIVE_LOG",
	FREE_TOUR = "FREE_TOUR",

	// add on feature modules
	TIME_AND_VACATION_ACCOUNT = "TIME_AND_VACATION_ACCOUNT",
	WORKING_TIME_PLUS = "WORKING_TIME_PLUS",
	PROJECT_TIME_PLUS = "PROJECT_TIME_PLUS",

	// extension feature modules
	EXTENDED_PERMISSIONS = "EXTENDED_PERMISSIONS",
}

export enum ModuleDiscountType {
	TOTAL = "TOTAL",
	SELECTED_MODULES = "SELECTED_MODULES"
}

export enum FeatureModuleStatus {
	DRAFT = "DRAFT",
	PRIVATE = "PRIVATE",
	IAP = "IAP",
	MAIN = "MAIN",
	LEGACY = "LEGACY",
	DISCONTINUED = "DISCONTINUED",
	EXPERIMENTAL = "EXPERIMENTAL"
}

export enum PricingChangeType {
	NONE = "NONE",
	UPGRADE = "UPGRADE",
	DOWNGRADE = "DOWNGRADE"
}

export enum FlexTimeIndicator {
	GREEN = "GREEN",
	YELLOW = "YELLOW",
	RED = "RED"
}

export enum AutomaticOvertimeCappingPeriod {
	NONE = "NONE",
	MONTHLY = "MONTHLY",
	// Will be implemented in the future
	// QUARTERLY = "QUARTERLY",
	// YEARLY = "YEARLY",
	// CUSTOM = "CUSTOM"
}

export enum CutHandlingMode {
	DOCUMENT = "DOCUMENT",
	VALIDATION = "VALIDATION"
}

export enum RecordingMode {
	CUSTOM = "CUSTOM",
	CLASSIC = "CLASSIC",
	COMBINED = "COMBINED",
	STRICT = "STRICT"
}

export enum CompensationType {
	/**
	 * Full compensation of the recorded duration.
	 */
	FULL = "FULL",
	/**
	 * Full compensation of the recorded duration only within the daily normal working time.
	 * Outside the daily normal working time no compensation.
	 */
	FULL_WITH_DAILY_NORMAL_WORKING_TIME_ONLY = "FULL_WITH_DAILY_NORMAL_WORKING_TIME_ONLY",
	/**
	 * Compensation of the recorded duration based on a percentage creditability.
	 */
	WITH_PERCENTAGE_CREDITABILITY = "WITH_PERCENTAGE_CREDITABILITY",
	/**
	 * Compensation of the recorded duration minus a fixed deductible.
	 */
	WITH_DURATION_DEDUCTIBLE = "WITH_DURATION_DEDUCTIBLE",
	/**
	 * Compensation of the recorded duration based on a percentage creditability
	 * only for the duration outside the daily normal working time.
	 * Inside the daily normal working time full compensation.
	 */
	WITH_PERCENTAGE_CREDITABILITY_OUTSIDE_DAILY_NORMAL_WORKING_TIME = "WITH_PERCENTAGE_CREDITABILITY_OUTSIDE_DAILY_NORMAL_WORKING_TIME",
	/**
	 * Full compensation of the recorded duration only for the duration outside the daily normal working time.
	 * Inside the daily normal working time full compensation.
	 */
	FULL_OUTSIDE_DAILY_NORMAL_WORKING_TIME = "FULL_OUTSIDE_DAILY_NORMAL_WORKING_TIME"
}

export enum TravellingTimeTargetAccount {
	TIME_ACCOUNT = "TIME_ACCOUNT",
	TRAVELLING_TIME_ACCOUNT = "TRAVELLING_TIME_ACCOUNT"
}

export enum AutomaticBreakDeductionPolicy {
	DEDUCTION_ALLOWED = "DEDUCTION_ALLOWED",
	PREFER_NOT_TO_DEDUCT = "PREFER_NOT_TO_DEDUCT",
	NEVER_DEDUCT = "NEVER_DEDUCT"
}

export enum WorkScheduleModelFilter {
	NONE = "NONE",
	EXACT = "EXACT"
}

export enum FlexTimeIndicatorType {
	NOT_ACTIVE = "NOT_ACTIVE",
	FIX_DURATION = "FIX_DURATION",
	PERCENTAGE = "PERCENTAGE"
}

export enum MailDeliveryStatus {
	BOUNCED = "BOUNCED",
	DELIVERED = "DELIVERED"
}

/**
 * IMPORTANT Do not change names because serialization in the mobile apps will fail then: MobileTaskSelectionType.java
 */
export enum MobileTaskSelectionType {
	ALL = "ALL",
	RECOMMENDED_AND_RECENT = "RECOMMENDED_AND_RECENT",
	BARCODE = "BARCODE",
	LOCATION = "LOCATION",
	FAVORITE = "FAVORITE"
}

export enum DateTimeChangeableByUserDayRangeMode {
	WARNING = "WARNING",
	PREVENT_EDIT = "PREVENT_EDIT"
}

export enum TaskStatusFilter {
	ALL = "ALL",
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE"
}

export enum ClientSegmentation {
	FREELANCER = "FREELANCER",
	COMPANY_MYSELF_ONLY = "COMPANY_MYSELF_ONLY",
	COMPANY_TEAM = "COMPANY_TEAM"
}

export enum CompanySizeType {
	ONE = "ONE",
	SOME = "SOME",
	MANY = "MANY",
	SIXTEEN_USERS = "SIXTEEN_USERS",
	THIRTY_SIX_USERS = "THIRTY_SIX_USERS",
	ONE_HUNDRED_ONE_USERS = "ONE_HUNDRED_ONE_USERS",
	FREE = "FREE"
}

export enum BreakModelSelectionStatus {
	NONE = "NONE",
	RULE_SELECTED = "RULE_SELECTED",
	EXPLICITLY_NONE = "EXPLICITLY_NONE"
}

export enum HolidayDayDuration {
	NONE = "NONE",
	HALF_DAY = "HALF_DAY",
	FULL_DAY = "FULL_DAY"
}

export enum HolidayCalendarGenerationMode {
	ON = "ON",
	OFF = "OFF",
	OFF_LEGACY = "OFF_LEGACY"
}

export enum WorkingTimeRequestStepConfigurationType {
	ADMINISTRATOR = "ADMINISTRATOR",
	SUBSTITUTE = "SUBSTITUTE",
	USER = "USER",
	TEAM_LEADER_DIRECT_OR_HIGHER = "TEAM_LEADER_DIRECT_OR_HIGHER",
	TEAM_LEADER_OR_ADMINISTRATOR = "TEAM_LEADER_OR_ADMINISTRATOR"
}

export enum RecordingValidationsMode {
	Personal = "PERSONAL",
	Manager = "MANAGER"
}

export enum WorkScheduleModelType {
	FIXED_WEEK = "FIXED_WEEK",
	ALTERNATING_WEEKS = "ALTERNATING_WEEKS"
}

export enum ReportViewType {
	DAILY = "DAILY",
	WEEKLY = "WEEKLY"
}

export enum RecordingValidationsManagerRoleFilter {
	ALL = "ALL",
	TEAM_LEADER = "TEAM_LEADER",
	TASK_LEADER = "TASK_LEADER"
}

export enum TimeNavigationType {
	Day, Week, Month, Quarter, Year, Total, Custom
}

export enum ProjectTimeReportAttachmentsPerRow {
	NONE = "NONE",
	ONE = "ONE"
}

export enum RecordingLockType {
	Recordable = "RECORDABLE",
	LockedAutomatically = "LOCKED_AUTOMATICALLY",
	LockedManually = "LOCKED_MANUALLY",
	UnlockedManually = "UNLOCKED_MANUALLY"
}

	export enum ProofRequirement {
		/**
		 * Proof documents are required
		 */
		REQUIRED = "REQUIRED",
        
		/**
		 * Proof documents are optional
		 */
		OPTIONAL = "OPTIONAL",

		/**
		 * Proof documents are not applicable
		 */
		NOT_APPLICABLE = "NOT_APPLICABLE",

		/**
		 * FRONTEND ONLY: Proof documents are required after a certain number of days
		 */
		REQUIRED_AFTER_DAYS = "REQUIRED_AFTER_DAYS"
	}

	export enum ProofStatus {
		/**
		 * Proof documents are optional and not yet uploaded.
		 */
		OPTIONAL = "OPTIONAL",

		/**
		 * Proof documents are required but not yet uploaded
		 */
		MISSING = "MISSING",

		/**
		 * Proof documents have been uploaded and are ready to be reviewed
		 */
		PENDING_REVIEW = "PENDING_REVIEW",

		/**
		 * Proof documents have been reviewed and accepted.
		 */
		ACCEPTED = "ACCEPTED",

		/**
		 * Proof documents have been reviewed and rejected.
		 */
		REJECTED = "REJECTED"
	}

	export enum ProofReviewAction {
		/**
		 * The proof has not been reviewed.
		 */
		NOT_REVIEWED = "NOT_REVIEWED",

		/**
		 * The proof has been reviewed and accepted.
		 */
		ACCEPTED = "ACCEPTED",

		/**
		 * The proof has been reviewed and rejected.
		 */
		REJECTED = "REJECTED"
	}

	/**
	 * Controls how a period is split into inside/outside normal working time.
	 *
	 * Backend reference: `NormalWorkingTimeCalculator` (supports both position-based (time-of-day) and duration-based
	 * splits).
	 */
    export enum NormalWorkingTimeEvaluationMode {
		/** No normal-working-time split is applied. */
	    INDEPENDENT = "INDEPENDENT",

		/** Position-based split: uses configured normal working time windows (time-of-day). */
	    POSITION = "POSITION",

		/** Duration-based split: uses daily working time duration and fills it in start order. */
	    DURATION = "DURATION",

		/** Applies both constraints (POSITION + DURATION). */
		POSITION_AND_DURATION = "POSITION_AND_DURATION"
    }

	/**
	 * Backend reference: `FixedBreakType`
	 */
	export enum FixedBreakType {
		NONE = "NONE",
		ALL_DAYS_EQUAL = "ALL_DAYS_EQUAL",
		PER_DAY = "PER_DAY"
	}
